
import 'vue-slider-component/theme/material.css';
import Multiselect from 'vue-multiselect';
import productFilterSliderInputMixins from '~/mixins/productFilterSliderInputMixins.js';

export default {
  name: 'FilterSlider',

  components: {
    Multiselect,
  },
  mixins: [productFilterSliderInputMixins],
  props: {
    filterTitle: {
      type: String,
      required: true,
      default: '',
    },
    actualValue: {
      required: true,
      // default: () => {},
    },
    filterOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
    filterIcon: {
      type: String,
      default: '',
    },
    sliderFixedRange: {
      type: Array,
      required: true,
      default: () => [],
    },
    mode: {
      type: String,
      required: false,
      default: 'default',
    },
    step: {
      type: Number,
      required: false,
      default: 1000,
    },
    disableScrollTop: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  data() {
    return {
      tempValue: this.actualValue,
      placeholderValue: { value: ['', ''], text: this.filterTitle },
      displayValue: this.actualValue,

      fixedRange: [parseInt(this.sliderFixedRange[0] ?? '0'), parseInt(this.sliderFixedRange[1] ?? '100')],
      isBlock: false,

      sliderInternalValue: this.actualValue.value,
      marks: this.generateMarks(parseInt(this.sliderFixedRange[0] ?? '0'), parseInt(this.sliderFixedRange[1] ?? '100'), this.step),
      inputType: 'number',
    };
  },

  watch: {
    actualValue(newValue) {
      if ( newValue ) {
        this.displayValue = newValue;
      }
    },

    'displayValue.value': {
      handler(newValue) {
        if (!this.customInput) this.sliderInternalValue = newValue;
      },
    },

    filterOptions: {
      handler(newValue) {
        if (this.isMobile() || !this.customInput) this.$emit('update:actualValue', newValue[0]);
      },
      deep: true,
    },
  },

  mounted() {
    this.addPaddingBottomToLastOption();

    if ( this.customInput ) {
      // Force show number keyboard on touch device
      if ( this.isMobile() ) this.inputType = 'tel';
    } else if (this.displayValue?.text) {
      this.addCustomSelectedClass();
    }
  },

  methods: {
    addPaddingBottomToLastOption() {
      const selectElements = this.$refs.multiselect?.$el?.querySelectorAll(
        '.multiselect__content-wrapper > .multiselect__content > .multiselect__element'
      );

      if (selectElements == null) return;

      const lastSelectElement = selectElements[selectElements.length - 1];

      if (lastSelectElement == null) return;

      const lastSelectElementOption = lastSelectElement.querySelector('.multiselect__option');

      if (lastSelectElementOption == null) return;

      lastSelectElementOption.style.paddingBottom = '15px';
    },

    // indicating a value is selected
    addCustomSelectedClass() {
      const tagsElement = this.$refs.multiselect.$el?.querySelector('.multiselect__tags');
      const selectElement = this.$refs.multiselect.$el?.querySelector('.multiselect__select');
      tagsElement?.classList.add('custom-selected');
      selectElement?.classList.add('custom-selected');
    },

    removeCustomSelectedClass() {
      const tagsElement = this.$refs.multiselect.$el?.querySelector('.multiselect__tags');
      const selectElement = this.$refs.multiselect.$el?.querySelector('.multiselect__select');
      tagsElement?.classList.remove('custom-selected');
      selectElement?.classList.remove('custom-selected');
    },

    blockDropdown() {
      this.isBlock = true;

      setTimeout(() => {
        this.isBlock = false;
      }, 500);
    },

    onInput(dropdownValue) {
      setTimeout(() => {
        this.addCustomSelectedClass();
      }, 400);

      // save to tempValue
      // this.tempValue = value;

      // const mValue = {value: dropdownValue, text: this.filterTitle};

      // modify actualValue
      this.$emit('update:actualValue', dropdownValue);
    },

    onOpened() {
      this.removeCustomSelectedClass();
      if ( !this.customInput ) this.$refs.multiselect?.$el?.focus();

      // temporarily change to placeholder text
      // this.displayValue = this.placeholderValue;
    },

    onClosed(value) {
      this.blockDropdown();
      // this.$emit('update:actualValue', value);

      // this.displayValue = this.tempValue;
      setTimeout(() => {
        this.addCustomSelectedClass();
      }, 400);
      window.scrollTo(0, 0);
    },

    onDragged(value, index) {
      this.sliderInternalValue = value;
    },

    // open() {
    //   this.$refs.multiselect.activate();
    // },

    isMobile() {
      // for detecting iPad pro workaround
      if (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) return true;

      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },

    generateMarks(start, end, step = 1000) {
      const resultMarks = [];
      for (let i = start; i <= end; i += step) {
        resultMarks.push(i);
      }
      return resultMarks;
    },
  }
};
